export const membershipCarDatas = [
  {
    id: 1,
    tier: "BASIC",
    price: 50,
    anuallyPrice: 550,
    membershipIncludes: [
      {
        id: 1,
        membershipIncludes: "unlimited Gym Access",
        included: true,
      },
      {
        id: 2,
        membershipIncludes: "3 training programs",
        included: true,
      },
      {
        id: 3,
        membershipIncludes: "Free Fitness Consultation",
        included: true,
      },
      {
        id: 4,
        membershipIncludes: "30% off drinks",
        included: true,
      },

      {
        id: 5,
        membershipIncludes: "Free WiFi",
        included: true,
      },

      {
        id: 6,
        membershipIncludes: "personal Trainers",
        included: false,
      },

      {
        id: 7,
        membershipIncludes: "Free Clothes & equipments",
        included: false,
      },
    ],
    primier: false,
  },
  {
    id: 2,
    tier: "PREMIER",
    price: 90,
    anuallyPrice: "1,150",
    membershipIncludes: [
      {
        id: 1,
        membershipIncludes: "unlimited Gym Access",
        included: true,
      },
      {
        id: 2,
        membershipIncludes: "All training programs",
        included: true,
      },
      {
        id: 3,
        membershipIncludes: "Free Fitness Consultation",
        included: true,
      },
      {
        id: 4,
        membershipIncludes: "Personal Trainers",
        included: true,
      },

      {
        id: 5,
        membershipIncludes: "Free Clothes & equipments",
        included: true,
      },

      {
        id: 6,
        membershipIncludes: "50% off drinks",
        included: true,
      },

      {
        id: 7,
        membershipIncludes: "Free wiFi",
        included: true,
      },
    ],
    primier: true,
  },
  {
    id: 3,
    tier: "ELITE",
    price: 65,
    anuallyPrice: 750,
    membershipIncludes: [
      {
        id: 1,
        membershipIncludes: "unlimited Gym Access",
        included: true,
      },
      {
        id: 2,
        membershipIncludes: "5 training programs",
        included: true,
      },
      {
        id: 3,
        membershipIncludes: "Free Fitness Consultation",
        included: true,
      },
      {
        id: 4,
        membershipIncludes: "45% off drinks",
        included: true,
      },

      {
        id: 5,
        membershipIncludes: "Free WiFi",
        included: true,
      },

      {
        id: 6,
        membershipIncludes: "Free Clothes & equipments",
        included: true,
      },

      {
        id: 7,
        membershipIncludes: "personal Trainers",
        included: false,
      },
    ],
    primier: false,
  },
];
